import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.css']
})
export class NotificationsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// C:/Visual Studio Projects/Novicell Performance Platform/PerformancePlatform/Novicell.Performance.Website/ui/src/app/components/notifications/notifications.component.ts